import React, { useEffect } from "react";
import { Modal, Box, TextField } from "@mui/material";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";

const LocationTagModal = ({ open, handleClose, provider, onSave }) => {
  const initialValues = {
    locationTag: provider?.locationTag || "",
  };

  const validationSchema = Yup.object({
    locationTag: Yup.string()
    .nullable()
    .transform((value) => (value === "" ? null : value))
    .notRequired(),
  });

  const handleSubmit = (values) => {
    const providerId =  provider?.id;
    if (onSave) {
      onSave(providerId, values.locationTag);
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          background: "#fff",
          width: "450px",
          p: 3,
          borderRadius: "10px",
          boxShadow: 5,
        }}
      >
        <h3 className="mb-3">Edit Location Tag</h3>

        <Formik
          enableReinitialize
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ errors, touched, setFieldValue, values }) => (
            <Form>
              <TextField
                fullWidth
                name="locationTag"
                label="Location Tag"
                value={values.locationTag}
                onChange={(e) => setFieldValue("locationTag", e.target.value)}
                error={touched.locationTag && Boolean(errors.locationTag)}
                helperText={touched.locationTag && errors.locationTag}
              />

              <div className="row mt-4">
                <div className="col-lg-12 col-md-12 col-sm-12">
                  <div className="text-end modalactions">
                    <button
                      type="button"
                      className="btn btn-light me-2"
                      onClick={handleClose}
                    >
                      Cancel
                    </button>

                    <button type="submit" className="btn btn-blacked">
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </Box>
    </Modal>
  );
};

export default LocationTagModal;
